import type { Role } from "~/server/rbac/roles";

export const ROLE_LABELS: Record<Role, string> = {
  admin: "Adminisztrátor",
  operator: "Operátor",
  coach: "Edző",
  user: "Sportoló",
};
